import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Form from 'components/form'
import { useForm } from 'react-hook-form'
import Button from 'components/Button'
import { ArrowLeftIcon } from 'components/icons'
import Checkbox from 'components/form/Checkbox'
import PublicModalDrawer from 'components/PublicModalDrawer'
import { useMutation } from 'react-query'
import ApiClient from 'data/api/api_client'
import { useDispatch } from 'react-redux'
import { setUser } from 'store/auth'
import useErrorHandler from 'data/hooks/useErrorHandler'
import StatusPanel from 'components/StatusPanel'
import { CheckCircleIcon } from 'components/icons'
import ModalNavControl from 'components/ModalNavControl'

const CustomerRegisterModal = ({ isOpen = false, onClose = () => { } }) => {
  const dispatch = useDispatch()
  const handleError = useErrorHandler()

  const [success, setSuccess] = useState(false)

  const { register, handleSubmit, setError, formState: { errors }, setValue, watch, clearErrors } = useForm()

  const registerMutation = useMutation(
    (fields) => ApiClient.auth.register(fields),
    {
      onSuccess: (user) => {
        dispatch(setUser(user))
        setSuccess(true)
      },
      onError: (error) => {
        handleError(error, setError)
      },
    },
  )

  return (
    <PublicModalDrawer className="h-full pt-90" isOpen={isOpen} onClose={() => onClose(true)} zIndex="z-[70]">
      {
        success
          ? <div className="flex items-center justify-center h-full pb-50">
            <StatusPanel
              icon={<CheckCircleIcon />}
              title="Successfully Registered"
              description="Your account has been created successfully"
            />
          </div>
          : <form onSubmit={handleSubmit(registerMutation.mutate)} className="flex flex-col">
            <button
              type="button"
              className="absolute focus:outline-none focus:text-primary top-20 stroke-2 left-20 cursor-pointer"
              onClick={() => onClose()}
            >
              <ArrowLeftIcon />
            </button>
            <h1 className="font-serif font-bold tracking-title leading-28 text-26 text-grey-800">Join A.M.A Selections</h1>

            <label className="text-14 leading-20 mt-30 text-grey-800">
              First Name
              <Form.Input
                style="customer"
                className="mt-10"
                placeholder="Your Name Here"
                error={errors?.first_name?.message}
                {...register('first_name')}
              />
            </label>

            <label className="text-14 leading-20 mt-20 text-grey-800">
              Last Name
              <Form.Input
                style="customer"
                className="mt-10"
                placeholder="Your Last Name Here"
                error={errors?.last_name?.message}
                {...register('last_name')}
              />
            </label>

            <label className="text-14 leading-20 mt-20 text-grey-800">
              Email Address
              <Form.Input
                style="customer"
                className="mt-10"
                placeholder="Your Email Here"
                type="email"
                error={errors?.email?.message}
                {...register('email')}
              />
            </label>

            <label className="text-14 leading-20 mt-20 text-grey-800">
              Password
              <Form.Input
                style="customer"
                className="mt-10"
                type="password"
                placeholder="••••••••"
                error={errors?.password?.message}
                {...register('password')}
              />
            </label>

            <label className="text-14 leading-20 mt-20 text-grey-800">

              <div className="flex gap-15">
                <div className="max-w-[135px] w-full flex flex-col gap-10">
                  <label>Country Code</label>
                  <Form.CountryCodeSelect
                    onChange={(input) => {
                      setValue('phone_country_code', input)
                      clearErrors('phone_country_code')
                    }}
                    value={watch('phone_country_code')}
                    style="customer"
                    error={errors?.phone_country_code}
                  />

                </div>
                <div className="w-full">
                  Phone
                  <Form.Input
                    style="customer"
                    className="mt-10"
                    placeholder="Your Phone Number"
                    error={errors?.phone?.message}
                    {...register('phone')}
                  />
                </div>

              </div>
            </label>

            <label className="text-14 leading-20 mt-20 text-grey-800">
              How did you hear about us?
              <Form.Select
                style={'customer'}
                error={errors?.booking_channel?.message}
                {...register('booking_channel')}
                value={watch('booking_channel')}
                className="mt-10"
                onChange={(e) => setValue('booking_channel', e.target.value)}
              >
                <Form.Option key={-1} value={''} selected={true} disabled={true}>Choose</Form.Option>
                <Form.Option value="airbnb">Airbnb / VRBO</Form.Option>
                <Form.Option value="facebook">Facebook</Form.Option>
                <Form.Option value="google">Google Search</Form.Option>
                <Form.Option value="instagram">Instagram</Form.Option>
                <Form.Option value="marriott">Marriott</Form.Option>
                <Form.Option value="press">Press</Form.Option>
                <Form.Option value="referral">Referral</Form.Option>
              </Form.Select>
            </label>

            <Checkbox
              className="mt-20 leading-20"
              style="customer"
              error={errors?.privacy_accepted?.message}
              {...register('privacy_accepted')}
            >
              <span className="text-14 text-grey-800">I have read and accepted the </span>
              <ModalNavControl.Link
                className="text-primary underline font-semibold text-14"
                text="Privacy Policy"
                href="/privacy-policy"
              />
            </Checkbox>

            <Button type="submit" block className="mt-40 uppercase" isLoading={registerMutation.isLoading}>Sign up</Button>
          </form>
      }
    </PublicModalDrawer>
  )
}

CustomerRegisterModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
}

export default CustomerRegisterModal
